// Constants for your portfolio
export const PERSONAL_INFO = {
    name: 'Dennis Sharon Cheruvathoor',
    title: 'Designer & Developer',
    location: 'Boston, MA',
    email: 'csdsharon@gmail.com',
    github: 'https://github.com/cheruvathoorshajd',
    linkedin: 'https://www.linkedin.com/in/csdsharon',
    resume: 'https://drive.google.com/file/d/1MCGopgWRm_wx6UcyJp4G_KgLeZFkk_lZ/view?usp=sharing',
    avocations: 'https://cheruvathoor.my.canva.site/photography-portfolio'
};

export const ABOUT = {
    paragraphs: [
        "Twelve years ago, I first discovered HTML in 7th grade, which left me in awe yet disappointed by its limitations. Fast-forward to 2025, and I'm pursuing my Master in Information Systems at Northeastern University, Boston, MA.",
        "With a passion for technology and design, I'm honing my skills as an aspiring Full-Stack Developer and UI/UX Designer, continuously on the path of learning."
    ],
    image: '/Boston.png',
    imageAlt: 'Boston'
};

export const TECHNICAL_SKILLS = [
    'JavaScript',
    'TypeScript',
    'HTML',
    'CSS',
    'SCSS (Sass)',
    'Python',
    'React.js',
    'Node.js',
    'MySQL',
    'MongoDB',
    'Express.js',
    'Redux',
    'Mongoose',
    'Gulp',
    'Vue',
    'RESTful APIs',
    'Git'
];

export const DESIGN_SKILLS = [
    'UI/UX Design',
    'Usability Testing',
    'Agile',
    'Scrum',
    'Balsamiq',
    'Figma',
    'Sketch',
    'Adobe XD',
    'Moqups',
    'WordPress',
    'Photoshop',
    'Canva',
    'UI/UX Testing'
];

export const PROJECTS = [
    {
        id: 1,
        title: 'BizzNex',
        category: 'Design & Development',
        image: '/BizzNex logo.png',
        link: 'https://csdsharon.my.canva.site/my-silhouette-exhibition',
        description: 'A comprehensive business networking platform'
    },
    {
        id: 2,
        title: 'AviaOhr',
        category: 'Design & Development (On-Going)',
        image: '/AviaOhr.png',
        link: 'https://csdsharon.my.canva.site/my-silhouette-exhibition',
        description: 'Aviation management system'
    },
    {
        id: 3,
        title: 'VOND.2',
        category: 'Design & Development',
        image: '/VOND.2.png',
        link: 'https://csdsharon.my.canva.site/my-silhouette-exhibition',
        description: 'Modern web application'
    },
    {
        id: 4,
        title: 'MedStar',
        category: 'Design & Development',
        image: '/Medstar.png',
        link: 'https://csdsharon.my.canva.site/my-silhouette-exhibition',
        description: 'Healthcare management solution'
    }
];

export const GREETINGS = [
    ". Olá",      // Portuguese
    ". שלום",      // Hebrew
    ". Γεια σας",  // Greek
    ". Ciao",     // Italian
    ". 你好",      // Chinese
    ". こんにちは",  // Japanese
    ". Bonjour"   // French
];

export const THEME = {
    colors: {
        background: '#0f0f0f',
        text: '#ffffff',
        accent: '#ff3c00',
        secondary: '#333333',
        lightGray: '#f5f5f5',
        blue: '#5352ed'
    },
    fonts: {
        heading: "'Della Respira', serif",
        body: "'Hatton', sans-serif"
    },
    transitions: {
        default: '0.5s cubic-bezier(0.33, 1, 0.68, 1)'
    }
};
